import { render, staticRenderFns } from "./Filtrele.vue?vue&type=template&id=a0586e1e&scoped=true"
import script from "./Filtrele.vue?vue&type=script&lang=js"
export * from "./Filtrele.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0586e1e",
  null
  
)

export default component.exports